import { useEffect } from "react";

const useBackListener = (callback) => {
  useEffect(() => {
    const handlePopState = (event) => {
      callback({ location: window.location, action: "POP", event });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [callback]);
};

export default useBackListener;
